<app-header *ngIf="url1"></app-header>

<mat-drawer-container class="mat-typography" [ngClass]="url1 ? '' : 'mat-drawer-container-nooauth'" autosize>
    <app-side-nav *ngIf="url1"></app-side-nav>

    <main [ngClass]="url1 ? 'main' : 'html-newnoauth'">
        <div>
            <router-outlet></router-outlet>
        </div>
    </main>
</mat-drawer-container>
